export default __webpack_public_path__ + "static/media/certified.c264b74c.png";